import Service from "./service";
import Footer from "./footer";

function ServicePage(){
    return(
        <>
         <Service/>
         <Footer/>
         </>
    )
}

export default ServicePage;